import { PrepareQuestion } from "../../organism/prepare-question/PrepareQuestion";

export const prepareQuestionList: PrepareQuestion[] = [
  {
    questionNo: 6,
    question: ["お金の使い方や暮らし方について一番近い考え方をお選びください♪"],
    teacherComment: [
      "あなたのことについて教えてください♪",
    ],
    greenComment:[],
    blackComment:[],
    answerList: [
      {
        answerNo: 1,
        answer: "ムダづかいは避けて、将来に備えていきたい",
      },
      {
        answerNo: 2,
        answer: "将来の準備も気にしつつ、今の生活も楽しみたい",
      },
      {
        answerNo: 3,
        answer: "将来の準備は気にせず、今を思いきり楽しみたい",
      },
    ],
  },
  {
    questionNo: 7,
    question: ["旅行を計画する際、あなたの考え方に一番近いものはどれですか？"],
    teacherComment: [
      "ご家族のことを思い浮かべながら、最も近いと感じる選択肢をお選びください♪",
    ],
    greenComment:[],
    blackComment:[],
    answerList: [
      {
        answerNo: 1,
        answer: "コスパ重視で、おトクに楽しみたい",
      },
      {
        answerNo: 2,
        answer: "ちょっとした贅沢も入れて、満足できる旅にしたい",
      },
      {
        answerNo: 3,
        answer: "希望を全部叶えて、とことん楽しみたい",
      },
    ],
  },
    {
    questionNo: 8,
    question: ["お子さまはどんな遊びが好きですか？"],
    teacherComment: [
      "お子さまのことを思い浮かべながら、「一番近いかも」と感じる選択肢をお選びください♪",
    ],
    greenComment:["お子さまが2人以上いる場合、第1子をイメージしてください。"],
    blackComment:[],
    answerList: [
      {
        answerNo: 1,
        answer: "ゲームを楽しんだり、本を読むのが好き",
      },
      {
        answerNo: 2,
        answer: "おしゃべりしたり、人と遊ぶのが好き",
      },
      {
        answerNo: 3,
        answer: "体を動かしたり、外で遊ぶのが好き",
      },
    ],
  },
  {
    questionNo: 9,
    question: ["お子さまには、どんなタイプの仕事が合いそうだと思いますか？"],
    teacherComment: [
      "お子さまのことを思い浮かべながら、「一番近いかも」と感じる選択肢をお選びください♪",
    ],
    greenComment:["お子さまが2人以上いる場合、第1子をイメージしてください。"],
    blackComment:["※どれも当てはまらないと感じた場合は、3つ目の選択肢をお選びください。"],
    answerList: [
      {
        answerNo: 1,
        answer: "自分のセンスや発想力を活かせる仕事",
      },
      {
        answerNo: 2,
        answer:
          "専門的なスキルや知識を深めていく仕事",
      },
      {
        answerNo: 3,
        answer:
          "決められたルールや手順にしっかり取り組む仕事",
      },
    ],
  },
  {
    questionNo: 4,
    question: [" お子さまには、将来どんな仕事に就いてほしいとお考えですか？"],
    teacherComment: ["お子さまのことを思い浮かべながら、「一番近いかも」と感じる選択肢をお選びください♪"],
    greenComment:["お子さまが2人以上いる場合、第1子をイメージしてください。"],
    blackComment:["※どれも当てはまらないと感じた場合は、2つ目の選択肢をお選びください。"],
    answerList: [
      {
        answerNo: 1,
        answer: "できれば安定した仕事に就いてほしい",
      },
      {
        answerNo: 2,
        answer: "子どもの気持ちを大切にしつつ、親として安心できる仕事だとうれしい",
      },
      {
        answerNo: 3,
        answer: "安定よりも、子どもが本当にやりたい仕事を応援したい",
      },
    ],
  },
  {
    questionNo: 5,
    question: [" お子さまには、将来どんな働き方をしてほしいと思いますか？"],
    teacherComment: ["お子さまのことを思い浮かべながら、「一番近いかも」と感じる選択肢をお選びください♪"],
    greenComment:["お子さまが2人以上いる場合、第1子をイメージしてください。"],
    blackComment:["※どれも当てはまらないと感じた場合は、2つ目の選択肢をお選びください。"],
    answerList: [
      {
        answerNo: 1,
        answer: "ひとつの会社でじっくり経験を深めながら働いてほしい",
      },
      {
        answerNo: 2,
        answer: "同じ会社でいろんな仕事にチャレンジして経験を積んでほしい",
      },
      {
        answerNo: 3,
        answer: "職場が変わってもいいので、自由にいろんな経験をしてほしい",
      },
    ],
  },
];
